import axios from 'axios';

const API_BASE = '/api/v1/users';

export interface User {
  _id: string;
  username: string;
  email?: string;
  name: string;
  tenantId: string;
  role?: any;
  active: boolean;
  mustChangePassword?: boolean;
  createdAt?: string;
  updatedAt?: string;
}

export interface CreateUserResult {
  user: User;
  tempPassword: string;
}

export const listUsers = async (): Promise<User[]> => {
  const response = await axios.get<User[]>(API_BASE, { withCredentials: true });
  return response.data;
};

export const createUser = async (data: any): Promise<CreateUserResult> => {
  const response = await axios.post<CreateUserResult>(API_BASE, data, { withCredentials: true });
  return response.data;
};

export const updateUser = async (id: string, data: any): Promise<User> => {
  const response = await axios.put<User>(`${API_BASE}/${id}`, data, { withCredentials: true });
  return response.data;
};

export const deleteUser = async (id: string) => {
  const response = await axios.delete(`${API_BASE}/${id}`, { withCredentials: true });
  return response.data;
};
